import React, { useState } from "react";
import "./POContent.scss";
import POCreateModal from "./POCreateModal";
import PODetailsModal from "./PODetailsModal";
import POTable from "./POTable";

const POContent = ({
  showPOCreateModal,
  setShowPOCreateModal,
  searchText,
  handleCreatePO,
}) => {
  const [poListKey, setPOListKey] = useState(0);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedPO, setSelectedPO] = useState(null);

  const handlePOCreated = () => {
    setPOListKey((prev) => prev + 1);
    if (handleCreatePO) {
      handleCreatePO();
    }
  };

  const handlePOSelect = (poDetails) => {
    setSelectedPO(poDetails);
    setShowDetailsModal(true);
  };

  return (
    <div className="inventory-content-container">
      <POTable
        key={poListKey}
        searchText={searchText}
        setShowPOCreateModal={setShowPOCreateModal}
        onPOSelect={handlePOSelect}
      />

      <POCreateModal
        showPOCreateModal={showPOCreateModal}
        setShowPOCreateModal={setShowPOCreateModal}
        onPOCreated={handlePOCreated}
      />

      {showDetailsModal && selectedPO && (
        <PODetailsModal
          onClose={() => setShowDetailsModal(false)}
          poData={selectedPO}
        />
      )}
    </div>
  );
};

export default POContent;
